// extracted by mini-css-extract-plugin
export default {"container":"MeetingPlayerDataOverlay_container__g9iz4","notReadyOverlay":"MeetingPlayerDataOverlay_notReadyOverlay__yRRQs"};